<script>
  import { format } from 'svelte-i18n';
  import { differenceInDays, set } from 'date-fns';

  import { Calendar } from '@client/components/calendar';

  import { PUSH_ACTION_COLORS, PUSH_ACTION_MODE } from '@client/enums';

  import DateModal from './date-modal.svelte';
  import Legend from './legend.svelte';

  export let history = [];
  export let loading = false;
  export let month = new Date().getMonth();
  export let year = new Date().getFullYear();
  export let onDays = (days) => {};

  let selected;
  let selectedDate;
  let show = false;

  $: events = loading
    ? {}
    : history.reduce((result, entry) => {
        const date = new Date(entry.timestamp);
        let key = `${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;

        const day = date.getDate();
        const dayEvents = result[key] && result[key][day] ? result[key][day] : [];

        return {
          ...result,
          [key]: {
            ...result[key],
            [day]: [
              ...dayEvents,
              {
                title: $format('label.BUSINESS_CARD'),
                color: PUSH_ACTION_COLORS['bizcard'],
                ...entry
              }
            ]
          }
        };
      }, {});

  $: if (!show) {
    selected = undefined;
    selectedDate = undefined;
  }

  const onDayClick = ({ date, events }) => {
    if (events && events.length) {
      selected = events;
      selectedDate = new Date(date.year, date.month - 1, date.day);
      show = true;
    }
  };

  const onMonthChange = (month, year) => {
    const today = new Date();
    const firstDayOfMonth = set(new Date(), { year, month: month - 1, date: 1 });

    onDays(differenceInDays(today, firstDayOfMonth));
  };
</script>

<Calendar bind:events bind:month bind:year enableFutureDates={false} {onDayClick} {onMonthChange} />

<Legend />

{#if show}
  <DateModal date={selectedDate} events={selected} bind:show />
{/if}
